import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';

import { Layout, Menu, Popconfirm } from 'antd';
import routes from '../constants/router';
import SubMenu from 'antd/es/menu/SubMenu';
import IconFinder from '../constants/icons';
import { LogOutIcon } from '../constants/icons/LogOutIcon';
import { useUserDataStore } from '../shared/store';
import { UserApi } from '../shared/api';
import { AddSellerBankInfo } from '../features/add-seller-bank-info.tsx/ui/AddSellerBankInfo';
const { Header, Sider, Content } = Layout;
function MainLayout({ children }) {
  const user = useUserDataStore((s) => s.user);
  const setUser = useUserDataStore((s) => s.setUser);
  const resetUserDataStore = useUserDataStore((s) => s.resetUserDataStore);
  const setSelectedEDS = useUserDataStore((s) => s.setSelectedEDS);
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [permission, setPermission] = useState(user?.roles?.[0]?.permissions || []);

  useEffect(() => {
    if (location.pathname !== '/login') {
      UserApi.getUserMe().then((res) => {
        localStorage.setItem('userData', JSON.stringify(res?.data));
        setUser(res?.data);
        setSelectedEDS(res?.data?.data);
        setPermission(res?.data?.roles?.[0]?.permissions);
      });
    }
  }, []);

  const confirm = (e) => {
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
    localStorage.removeItem('soliqToken');
    localStorage.removeItem('lang');
    resetUserDataStore();
    window.location.href = process.env.REACT_APP_REDIRECT_BUYER_URL;
  };
  const cancel = (e) => {
    console.log(e);
  };
  function menuGenerator(routes) {
    var renderMenu = permissionsRoutes(routes);
    return renderMenu?.map((e, i) => {
      if (e?.children && e?.children.length && !e?.noSub) {
        return (
          <SubMenu
            key={e.meta.title}
            icon={IconFinder(e?.meta?.icon)}
            title={
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                {e?.meta?.title}
              </div>
            }
          >
            {permissionsRoutes(e?.children).map((item, key) => (
              <Menu.Item key={item.path}>
                <Link to={item.path}>{item.meta.title}</Link>
              </Menu.Item>
            ))}
          </SubMenu>
        );
      } else {
        return (
          <Menu.Item key={e?.path} icon={IconFinder(e?.meta?.icon)}>
            <Link to={e?.path}>{e?.meta?.title}</Link>
          </Menu.Item>
        );
      }
    });
  }

  const permissionsRoutes = (routes) => {
    const generated = routes.filter(
      (item) =>
        permission?.find((i) => i.key === item.meta.permission) ||
        item?.children?.filter((item) => permission?.find((i) => i.key === item?.meta?.permission))?.length
    );
    return generated;
  };

  return user ? (
    <>
      {user?.is_owner && !user?.company?.bank?.account && !user?.company?.bank?.mfo && !user?.phone ? (
        <AddSellerBankInfo />
      ) : (
        <Layout style={{ height: '100vh', backgroundColor: '#fff' }}>
          <Sider
            trigger={null}
            style={{
              padding: 0,
              background: '#fff',
            }}
            collapsible
            collapsed={collapsed}
          >
            <div className='flex p-5 gap-2 border-b border-[#DDDDEF]'>
              <img src='/images/avatar.png' className='object-contain' alt='logo' width={45} height={45} />
              <div>
                <p className='text-lg font-medium truncate w-[180px]'>{user?.company?.name}</p>
                <p className='text-[#9898A6] text-sm font-medium'>vasit seller</p>
              </div>
            </div>
            <Menu
              theme='light'
              mode='inline'
              style={{
                overflowY: 'auto',
                maxHeight: '90vh',
              }}
              selectedKeys={[location.pathname]}
            >
              {menuGenerator(routes)}
            </Menu>
          </Sider>
          <Layout>
            <Header
              style={{
                padding: 0,
                backgroundColor: '#F5F5FC',
                borderBottom: '1px solid #DDDDEF',
              }}
            >
              <div className='w-full h-full flex px-[30px] justify-between items-center'>
                <img alt='' src='/logo.svg' className='px-[15px]' />
                <div
                  className='flex gap-2
              '
                >
                  <Popconfirm
                    title='Log out'
                    description='Are you sure about this task?'
                    onConfirm={confirm}
                    onCancel={cancel}
                    okText='Yes'
                    cancelText='No'
                  >
                    <button className='hover:bg-[#9898A6]/10 px-3 py-1 rounded-lg text-[#9898A6] font-medium text-base flex gap-2 items-center'>
                      <span>Log out</span>
                      <LogOutIcon />
                    </button>
                  </Popconfirm>
                </div>
              </div>
            </Header>
            <Content
              style={{
                margin: '20px 30px',
                minHeight: 280,
                overflowY: 'auto',
              }}
            >
              {children}
            </Content>
          </Layout>
        </Layout>
      )}
    </>
  ) : null;
}

export default MainLayout;
